<ng-template #modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="d-flex flex-column flex-center mb-5">
        @if (modalConfig.isWarning) {
        <mat-icon class="warning-icon">warning</mat-icon>
        } @else {
        <i class="bi bi-exclamation-circle text-danger fs-1"></i>
        }
        <h2 class="font-weight-bolder my-5">{{modalConfig.modalTitle}}</h2>
        <p [ngClass]="{ 'warning-description': modalConfig.isWarning }">
          {{ modalConfig.modalDesc }}
        </p>
      </div>
      <div class="text-center">
        @if (modalConfig.hideDismissButton === undefined || !modalConfig.hideDismissButton()) {
        <button type="button" ngbAutofocus class="btn btn-secondary me-4" (click)="dismiss()"
          [disabled]="modalConfig.disableDismissButton !== undefined && modalConfig.disableDismissButton()">
          {{ modalConfig.dismissButtonLabel }}
        </button>
        }
        @if (modalConfig.hideCloseButton === undefined || !modalConfig.hideCloseButton()) {
        <button type="button" class="btn" (click)="close()"
          [disabled]="modalConfig.disableCloseButton !== undefined && modalConfig.disableCloseButton()"
          [ngClass]="{ 'warning-btn': modalConfig.isWarning, 'btn-danger': !modalConfig.isWarning }">
          {{ modalConfig.closeButtonLabel }}
        </button>
        }
      </div>
    </div>
  </div>
</ng-template>